/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function NewUser() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'NewUser',
				config: {
					ruleType: "new_visitor",
					args:{
						isNewVisitor: true
					}
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			users
			that
			visit
			your
			website
			for
			the
			first
			time.
		</p>
	</>;
}
